import ResponsibleBanner from "@/components/ResponsibleBanner";
import { EDUCATION_TOPICS } from "@/lib/content";
import { Link } from "react-router-dom";
import { AlertTriangle, Phone, ExternalLink } from "lucide-react";

const POINTS = [
  "Sports betting involves risk.",
  "No strategy guarantees a winning wager.",
  "Only wager money you can afford to lose.",
  "Comply with the applicable laws where you live.",
  "Sportsbook Smasher provides education and information — not financial advice or guaranteed betting outcomes.",
];

const RESOURCES = [
  { label: "National Problem Gambling Helpline: 1-800-GAMBLER", href: "tel:1-800-426-2537" },
  { label: "National Council on Problem Gambling", href: "https://www.ncpgambling.org/" },
  { label: "Gamblers Anonymous", href: "https://www.gamblersanonymous.org/" },
];

export default function ResponsiblePage() {
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-14 space-y-10">
      <div>
        <div className="inline-flex items-center gap-2 text-xs font-bold tracking-[0.2em] text-smasher-orange mb-2"><AlertTriangle className="w-4 h-4" /> 21+</div>
        <h1 className="font-heading font-black uppercase text-4xl sm:text-5xl text-gradient-gold">Responsible Wagering</h1>
      </div>

      <div className="panel p-6 space-y-3">
        {POINTS.map((p) => (
          <div key={p} className="flex items-start gap-3 text-slate-200"><span className="w-1.5 h-1.5 rounded-full bg-smasher-gold mt-2 shrink-0" /> {p}</div>
        ))}
      </div>

      <div>
        <h2 className="font-heading font-bold text-xl text-white mb-4 flex items-center gap-2"><Phone className="w-5 h-5 text-smasher-gold" /> Get Help</h2>
        <div className="space-y-3">
          {RESOURCES.map((r) => (
            <a key={r.label} href={r.href} target="_blank" rel="noopener noreferrer" className="panel panel-hover p-4 flex items-center justify-between text-slate-200 hover:text-smasher-gold">
              {r.label} <ExternalLink className="w-4 h-4" />
            </a>
          ))}
        </div>
      </div>

      <Link to="/education/responsible-wagering" className="inline-block text-sm font-bold text-smasher-gold hover:text-smasher-orange">Read the Responsible Wagering lesson →</Link>
      <ResponsibleBanner />
    </div>
  );
}
